import { Injectable } from '@angular/core';
import { IEpViewModel } from '@epicor/ux-platform';
import { AppLocalizationStrings } from './app.localization.strings';

@Injectable()
export class AppCommonService {
  appStrings = AppLocalizationStrings;
  view: IEpViewModel;
}
